import gql from "graphql-tag";

export const queryCommunicationChannelForStick = gql`
  fragment communicationchannel on CommunicationChannel {
    CommunicationChannel
    LoggerModel
    LoggerFirmware
    LoggerStatus
  }
`;

export const queryLoggerData = gql`
  fragment loggerdatatype on LoggerDataType {
    ... on SolarmanDataType {
      loggerId
      devices {
        fota_status
        arm
        dspm
        dsps
        sn
      }
    }
  }
`;

export const queryInvUpgradeForWeb = gql`
  fragment sendinvupgraderesponse on SendInvUpgradeResponse {
    transactionId
    inverterId
    loggerId
    timestamp
    fileType
    totalSize
    fileCRC
    fileURL
  }
`;
